import ProjectTable from "@/app/app-shared/project/project-table";

type ProjectPageProps = {
  notAddedOnly?: boolean;
};

export default function ProjectPage({ notAddedOnly }: ProjectPageProps) {
  return <ProjectTable notAddedOnly={notAddedOnly} />;
}
